import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { DeviceDefinitionEdit } from "@/features/catalog";
import { deviceDefinitionRouteId } from "@/features/catalog/lib/device-definition-route";

export const Route = createFileRoute("/catalog/devices/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("DeviceDefinition")) throw redirect({ to: "/catalog/devices" });
  },
  component: NewDevice,
});

/**
 * A new device — the DEFINITION. Its instances are added from its own page
 * once it exists, so there is nothing to register here.
 */
function NewDevice() {
  const navigate = useNavigate();
  return (
    <DeviceDefinitionEdit
      canEdit
      onDone={(url) =>
        url
          ? navigate({ to: "/catalog/devices/$deviceId", params: { deviceId: deviceDefinitionRouteId(url) } })
          : navigate({ to: "/catalog/devices" })
      }
      onCancel={() => navigate({ to: "/catalog/devices" })}
    />
  );
}
